module.exports = __webpack_public_path__ + "img/Caminho4275.56f6e7cd.svg";